export const heroData = {
  tag: "夜晚追剧 · 安静观影",
  h1: "春夜影院 — 属于你的夜晚观影空间",
  slogan: "精选睡前电影清单，伴你度过每一个宁静春夜",
  intro: "春夜影院是一个专为夜晚观影爱好者打造的高清在线追剧平台。我们精心筛选适合夜晚观看的电影与剧集，从治愈系文艺片到深度悬疑佳作，从经典重温到冷门好片，为你打造一份专属的睡前电影清单。平台每日更新，所有影片支持高清流畅播放，无需缓冲，只需一盏台灯和一杯热饮，即可享受属于你自己的春夜观影时光。",
  stats: [
    { label: "精选片单", value: "2000+", desc: "持续更新中" },
    { label: "每日更新", value: "7×24", desc: "新片不断档" },
    { label: "高清画质", value: "1080P", desc: "流畅不缓冲" },
  ],
  primaryCta: { text: "探索片单", href: "#cards" },
  secondaryCta: { text: "了解更多", href: "#about" },
};

export const indexItems = [
  {
    id: "idx-1",
    title: "治愈系电影",
    subtitle: "温柔入梦",
    description: "温暖人心的治愈故事，适合睡前放松心情，带着微笑入眠。",
    icon: "ri-heart-line",
    href: "#cards",
  },
  {
    id: "idx-2",
    title: "深夜悬疑",
    subtitle: "烧脑时刻",
    description: "精选悬疑烧脑佳作，夜幕降临后与剧情一起屏息凝神。",
    icon: "ri-search-eye-line",
    href: "#cards",
  },
  {
    id: "idx-3",
    title: "浪漫爱情",
    subtitle: "心动之夜",
    description: "关于爱与相遇的故事，在春夜里感受电影中的温柔浪漫。",
    icon: "ri-moon-clear-line",
    href: "#cards",
  },
  {
    id: "idx-4",
    title: "经典重温",
    subtitle: "时光放映",
    description: "那些百看不厌的经典之作，每一个夜晚都值得再次回味。",
    icon: "ri-film-line",
    href: "#cards",
  },
  {
    id: "idx-5",
    title: "独立佳作",
    subtitle: "小众之光",
    description: "独立制片的精致作品，用独特的视角讲述不平凡的故事。",
    icon: "ri-lightbulb-line",
    href: "#cards",
  },
  {
    id: "idx-6",
    title: "动画世界",
    subtitle: "童心未泯",
    description: "从宫崎骏到新海诚，动画电影里的每一帧都是温柔梦境。",
    icon: "ri-magic-line",
    href: "#cards",
  },
  {
    id: "idx-7",
    title: "纪录片精选",
    subtitle: "真实力量",
    description: "精选优质纪录片，在安静的夜晚探索世界的无限可能性。",
    icon: "ri-earth-line",
    href: "#cards",
  },
];

export const topicsItems = [
  { id: "t-1", label: "春日治愈", count: "3.2万", hot: true },
  { id: "t-2", label: "失眠必看", count: "2.8万", hot: true },
  { id: "t-3", label: "高分神作", count: "5.1万", hot: true },
  { id: "t-4", label: "冷门佳片", count: "1.9万", hot: false },
  { id: "t-5", label: "女性故事", count: "2.4万", hot: true },
  { id: "t-6", label: "科幻迷思", count: "1.7万", hot: false },
  { id: "t-7", label: "日系美学", count: "3.6万", hot: true },
  { id: "t-8", label: "深夜食堂", count: "2.1万", hot: false },
  { id: "t-9", label: "城市夜景", count: "1.5万", hot: false },
  { id: "t-10", label: "独处时光", count: "4.3万", hot: true },
  { id: "t-11", label: "温柔配乐", count: "2.7万", hot: false },
];

export const updatesItems = [
  {
    id: "u-1",
    date: "2026.07.30",
    title: "本周上新 8 部精选影片",
    summary: "本周片单更新了 8 部高分电影，涵盖爱情、悬疑、动画等多个类型，其中《春之气息》评分高达 9.1 分。",
    tag: "上新",
  },
  {
    id: "u-2",
    date: "2026.07.25",
    title: "夏日深夜影院专题上线",
    summary: "特别策划「夏夜晚风」观影专题，精选 20 部适合在夏夜观看的清爽治愈系电影，搭配精心编排的观影顺序。",
    tag: "专题",
  },
  {
    id: "u-3",
    date: "2026.07.20",
    title: "平台画质全面升级至 1080P",
    summary: "即日起所有片源均支持 1080P 高清播放，优化了夜间模式的画面亮度和色彩表现，观影体验更舒适。",
    tag: "升级",
  },
  {
    id: "u-4",
    date: "2026.07.15",
    title: "用户推荐功能正式上线",
    summary: "现在你可以在每部影片下方看到其他观众的真实推荐语，也可以提交你喜欢的睡前电影推荐给更多朋友。",
    tag: "功能",
  },
  {
    id: "u-5",
    date: "2026.07.10",
    title: "七月片单收藏突破 2000 部",
    summary: "感谢每一位春夜观众的陪伴，我们的精选片单已经突破 2000 部，每一部都经过人工精选和主题分类。",
    tag: "里程碑",
  },
  {
    id: "u-6",
    date: "2026.07.05",
    title: "新增「助眠」系列电影推荐",
    summary: "针对失眠和入睡困难的朋友，我们特别推出「助眠」系列，精选节奏舒缓、画面柔和的轻量级电影。",
    tag: "上新",
  },
  {
    id: "u-7",
    date: "2026.07.01",
    title: "春夜影院正式上线",
    summary: "一个只为夜晚而生的观影平台正式与大家见面，愿每一个夜晚都有好电影和好心情相伴。",
    tag: "上线",
  },
];

export const faqItems = [
  {
    id: "faq-1",
    question: "春夜影院的影片可以免费观看吗？",
    answer: "是的，春夜影院目前所有收录的影片均支持免费在线观看。我们致力于为夜晚观影爱好者提供一个无需付费、无需注册即可畅享的高清追剧平台。",
  },
  {
    id: "faq-2",
    question: "为什么专注于夜晚观影推荐？",
    answer: "夜晚是许多人一天中最放松的时刻，观影体验与白天截然不同。我们特别筛选了适合在安静夜晚观看的电影——氛围感强、节奏舒适、画面温暖，帮助你在睡前获得最好的观影体验。",
  },
  {
    id: "faq-3",
    question: "影片画质和流畅度怎么样？",
    answer: "平台所有片源均支持 1080P 高清播放，采用先进的流媒体传输技术，确保播放流畅不缓冲。夜间模式还针对暗光环境优化了亮度和色温，长时间观看也不易疲劳。",
  },
  {
    id: "faq-4",
    question: "如何推荐自己喜欢的电影？",
    answer: "你可以通过页面的联系我们入口，提交你喜欢的睡前电影推荐。我们的编辑团队会认真筛选每一份推荐，优质推荐将被收录到平台片单中，分享给更多春夜观众。",
  },
];

export const featuresItems = [
  {
    id: "ft-1",
    icon: "ri-movie-line",
    title: "人工精选",
    description: "每部影片均由编辑团队观看后精选入库，拒绝算法堆砌，只推荐真正值得花时间观看的好电影，让每一次选择都安心。",
  },
  {
    id: "ft-2",
    icon: "ri-hd-line",
    title: "高清流畅",
    description: "全站支持 1080P 高清画质，采用智能 CDN 加速和自适应码率技术，确保在任何网络环境下都能流畅播放不卡顿。",
  },
  {
    id: "ft-3",
    icon: "ri-moon-fill",
    title: "夜间专属",
    description: "独特的夜间观影模式，画面亮度、色温、对比度均针对暗光环境优化，搭配安静的 UI 设计，打造沉浸式夜晚观影体验。",
  },
  {
    id: "ft-4",
    icon: "ri-user-heart-line",
    title: "氛围社区",
    description: "汇聚了一群热爱夜晚观影的朋友，分享观后感、推荐好片、交流观影心得，在安静的夜晚找到同频的人。",
  },
];

export const carouselItems = [
  {
    id: "cr-1",
    title: "春夜必看：五部治愈系电影",
    subtitle: "温柔到让你忘记一天疲惫",
    description: "精选五部画面唯美、节奏舒缓的治愈系电影，适合在春天的夜晚独自观看，让温柔的故事伴你入眠。",
    image: "https://readdy.ai/api/search-image?query=A%20cozy%20bedroom%20at%20night%20with%20soft%20warm%20lamp%20light%2C%20a%20laptop%20on%20the%20bed%20showing%20a%20gentle%20movie%20scene%2C%20cherry%20blossom%20petals%20floating%20outside%20the%20window%20in%20spring%20night%20breeze%2C%20fairy%20lights%20hanging%20on%20the%20wall%2C%20warm%20amber%20and%20soft%20pink%20tones%2C%20dreamy%20cinematic%20illustration%20style%20with%20peaceful%20atmosphere%2C%20digital%20art%20with%20painterly%20textures&width=800&height=500&seq=carousel-01&orientation=landscape",
  },
  {
    id: "cr-2",
    title: "悬疑之夜：烧脑片单推荐",
    subtitle: "关上灯，让大脑高速运转",
    description: "从经典推理到心理惊悚，我们整理了一份最适合深夜观看的悬疑电影清单，每一部都让人欲罢不能。",
    image: "https://readdy.ai/api/search-image?query=A%20dimly%20lit%20room%20with%20a%20large%20screen%20showing%20a%20mysterious%20film%20noir%20scene%20with%20dramatic%20shadows%2C%20a%20cup%20of%20steaming%20black%20coffee%20on%20a%20wooden%20side%20table%2C%20venetian%20blind%20shadows%20casting%20stripes%20across%20the%20wall%2C%20moody%20suspenseful%20atmosphere%20in%20warm%20sepia%20and%20deep%20brown%20tones%2C%20cinematic%20digital%20illustration%20with%20film%20grain%20texture&width=800&height=500&seq=carousel-02&orientation=landscape",
  },
  {
    id: "cr-3",
    title: "独处时光：一个人看的电影",
    subtitle: "享受与自己相处的夜晚",
    description: "有些电影适合一个人静静欣赏。我们为你挑选了最适合独处时观看的影片，让独处的夜晚也变得充实而美好。",
    image: "https://readdy.ai/api/search-image?query=A%20quiet%20minimalist%20room%20at%20night%20with%20a%20single%20person%20silhouette%20watching%20a%20glowing%20screen%2C%20warm%20amber%20light%20from%20a%20small%20table%20lamp%2C%20a%20purring%20cat%20curled%20up%20nearby%2C%20gentle%20moonlight%20streaming%20through%20sheer%20curtains%2C%20soft%20blankets%20and%20cushions%20creating%20a%20cozy%20nest%2C%20peaceful%20solitude%20atmosphere%20in%20warm%20neutral%20tones%2C%20painterly%20digital%20art%20style&width=800&height=500&seq=carousel-03&orientation=landscape",
  },
  {
    id: "cr-4",
    title: "约会之夜：情侣观影指南",
    subtitle: "和TA一起感受春夜的浪漫",
    description: "从浪漫喜剧到感人爱情片，我们准备了一份最适合两人一起观看的电影清单，让约会之夜更加甜蜜。",
    image: "https://readdy.ai/api/search-image?query=A%20romantic%20evening%20scene%20with%20two%20wine%20glasses%20on%20a%20wooden%20coffee%20table%20in%20front%20of%20a%20glowing%20TV%20screen%20showing%20a%20romantic%20movie%2C%20soft%20pink%20and%20rose%20gold%20fairy%20lights%20draped%20across%20the%20room%2C%20scattered%20rose%20petals%20on%20the%20floor%2C%20warm%20candlelight%20flickering%20gently%2C%20cozy%20blanket%20draped%20over%20a%20sofa%2C%20dreamy%20romantic%20atmosphere%20in%20soft%20warm%20tones%2C%20cinematic%20digital%20illustration&width=800&height=500&seq=carousel-04&orientation=landscape",
  },
  {
    id: "cr-5",
    title: "纪录片之夜：认识更大的世界",
    subtitle: "在安静中探索未知",
    description: "从自然风光到人文历史，精选五部制作精良的纪录片，让你在安静的夜晚足不出户也能看见世界的广阔。",
    image: "https://readdy.ai/api/search-image?query=A%20study%20room%20at%20night%20with%20a%20large%20screen%20displaying%20a%20stunning%20nature%20documentary%20scene%20of%20northern%20lights%20and%20starry%20sky%2C%20a%20globe%20on%20the%20desk%2C%20books%20scattered%20around%2C%20a%20warm%20desk%20lamp%20creating%20a%20cozy%20reading%20nook%20atmosphere%2C%20maps%20pinned%20on%20the%20wall%2C%20intellectual%20and%20peaceful%20ambiance%20in%20warm%20earthy%20tones%2C%20painterly%20digital%20art%20style&width=800&height=500&seq=carousel-05&orientation=landscape",
  },
];

export const cardsItems = [
  {
    id: "cd-1",
    title: "海上钢琴师",
    subtitle: "经典永恒 · 音乐人生",
    description: "一个从未下过船的天才钢琴家，用音乐讲述一生的故事。旋律悠扬，画面唯美，睡前观看尤为动人。",
    rating: 9.3,
    tag: "经典重温",
    image: "https://readdy.ai/api/search-image?query=A%20grand%20piano%20on%20an%20old%20ship%20deck%20at%20night%20under%20moonlight%2C%20gentle%20ocean%20waves%20in%20the%20background%2C%20warm%20golden%20light%20spilling%20from%20cabin%20windows%2C%20musical%20notes%20floating%20in%20the%20air%20like%20stardust%2C%20nostalgic%20romantic%20atmosphere%2C%20soft%20focus%20cinematic%20photography%20style%20with%20vintage%20film%20tones%2C%20warm%20amber%20and%20navy%20blue%20color%20palette&width=600&height=400&seq=card-01&orientation=landscape",
  },
  {
    id: "cd-2",
    title: "小森林 · 夏秋篇",
    subtitle: "治愈美食 · 田园生活",
    description: "女孩回到乡下老家，用四季食材烹饪简单美味。节奏舒缓，画面治愈，是睡前放松的最佳选择。",
    rating: 9.0,
    tag: "治愈系",
    image: "https://readdy.ai/api/search-image?query=A%20rustic%20Japanese%20countryside%20kitchen%20at%20dusk%20with%20fresh%20seasonal%20vegetables%20on%20a%20wooden%20table%2C%20steam%20rising%20from%20a%20cooking%20pot%2C%20warm%20lantern%20light%2C%20green%20forest%20visible%20through%20the%20window%2C%20peaceful%20rural%20atmosphere%20with%20soft%20natural%20lighting%2C%20cinematic%20food%20photography%20style%20with%20muted%20earth%20tones%20and%20gentle%20greens&width=600&height=400&seq=card-02&orientation=landscape",
  },
  {
    id: "cd-3",
    title: "楚门的世界",
    subtitle: "人生寓言 · 真假边界",
    description: "一个从出生就被全球直播的男人，终于发现自己的世界不过是一座巨大的摄影棚。引人深思，回味无穷。",
    rating: 9.3,
    tag: "高分神作",
    image: "https://readdy.ai/api/search-image?query=A%20surreal%20scene%20of%20a%20perfect%20suburban%20neighborhood%20with%20a%20painted%20sky%20backdrop%20at%20twilight%2C%20a%20lone%20figure%20standing%20at%20the%20edge%20looking%20toward%20an%20open%20door%20in%20the%20sky%20wall%2C%20artificial%20sun%20setting%2C%20warm%20golden%20hour%20light%20mixed%20with%20cool%20blue%20shadows%2C%20philosophical%20and%20contemplative%20atmosphere%2C%20cinematic%20digital%20art%20with%20surreal%20elements&width=600&height=400&seq=card-03&orientation=landscape",
  },
  {
    id: "cd-4",
    title: "情书",
    subtitle: "纯爱经典 · 冬日回忆",
    description: "一封寄往天国的情书，揭开了埋藏多年的青涩暗恋。岩井俊二的镜头语言温柔至极，每个画面都像一首诗。",
    rating: 8.9,
    tag: "浪漫爱情",
    image: "https://readdy.ai/api/search-image?query=A%20quiet%20snowy%20Japanese%20small%20town%20street%20at%20dusk%20with%20soft%20warm%20light%20glowing%20from%20a%20post%20box%2C%20delicate%20snowflakes%20falling%20gently%2C%20a%20solitary%20figure%20in%20a%20warm%20coat%20standing%20by%20the%20mailbox%2C%20nostalgic%20winter%20atmosphere%2C%20soft%20white%20and%20pale%20blue%20tones%20with%20touches%20of%20warm%20amber%2C%20dreamy%20soft%20focus%20cinematic%20photography%20style&width=600&height=400&seq=card-04&orientation=landscape",
  },
  {
    id: "cd-5",
    title: "寻梦环游记",
    subtitle: "亲情治愈 · 音乐之旅",
    description: "小男孩误入亡灵世界，在寻找曾曾祖父的旅途中领悟了家人的意义。色彩绚烂，故事感人，笑着笑着就哭了。",
    rating: 9.1,
    tag: "动画世界",
    image: "https://readdy.ai/api/search-image?query=A%20magical%20bridge%20made%20of%20glowing%20orange%20marigold%20petals%20stretching%20across%20a%20starry%20night%20sky%2C%20warm%20lanterns%20floating%20upward%2C%20a%20small%20guitar%20leaning%20against%20a%20stone%2C%20vibrant%20warm%20colors%20of%20orange%20gold%20and%20deep%20purple%2C%20Mexican%20folk%20art%20inspired%20patterns%2C%20dreamlike%20celebration%20atmosphere%2C%20animated%20film%20aesthetic%20digital%20art%20with%20rich%20textures&width=600&height=400&seq=card-05&orientation=landscape",
  },
  {
    id: "cd-6",
    title: "步履不停",
    subtitle: "家庭温情 · 人生步履",
    description: "一家人团聚的一天，平淡中藏着深厚的情感。是枝裕和的镜头安静而克制，看后让人久久回味。",
    rating: 8.8,
    tag: "独立佳作",
    image: "https://readdy.ai/api/search-image?query=A%20traditional%20Japanese%20house%20interior%20on%20a%20quiet%20summer%20afternoon%2C%20sunlight%20filtering%20through%20shoji%20screens%2C%20a%20family%20gathered%20around%20a%20low%20dining%20table%20with%20simple%20home%20cooked%20food%2C%20gentle%20breeze%20moving%20the%20curtains%2C%20peaceful%20domestic%20atmosphere%2C%20soft%20natural%20light%20with%20warm%20earthy%20tones%2C%20contemplative%20mood%20cinematography%20style&width=600&height=400&seq=card-06&orientation=landscape",
  },
  {
    id: "cd-7",
    title: "地球脉动 · 第二季",
    subtitle: "自然奇观 · 视觉盛宴",
    description: "BBC 顶级纪录片，用镜头捕捉地球上最震撼的生命故事。每一帧都可以截下来做壁纸，睡前观看开阔心胸。",
    rating: 9.9,
    tag: "纪录片",
    image: "https://readdy.ai/api/search-image?query=A%20breathtaking%20aerial%20view%20of%20snow%20capped%20mountains%20reflected%20in%20a%20crystal%20clear%20alpine%20lake%20at%20golden%20hour%2C%20wild%20animals%20grazing%20peacefully%20on%20the%20shoreline%2C%20dramatic%20clouds%20painted%20in%20warm%20orange%20and%20pink%20sunset%20colors%2C%20pristine%20wilderness%20in%20perfect%20natural%20harmony%2C%20BBC%20documentary%20style%20cinematography%20with%20epic%20scale%20and%20stunning%20detail&width=600&height=400&seq=card-07&orientation=landscape",
  },
];

export const commentsItems = [
  {
    id: "cm-1",
    name: "深夜观影者",
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20circular%20avatar%20icon%20in%20soft%20amber%20and%20cream%20colors%20with%20a%20subtle%20moon%20crescent%20shape%2C%20minimalist%20flat%20design%20style%2C%20clean%20and%20elegant&width=80&height=80&seq=avatar-01&orientation=squarish",
    text: "每天晚上睡前打开春夜影院已经成了习惯。这里的片单真的很有品味，每一部都适合在安静夜晚慢慢看。推荐给所有喜欢夜晚的朋友。",
    time: "3 天前",
  },
  {
    id: "cm-2",
    name: "电影爱好者小陈",
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20circular%20avatar%20icon%20in%20soft%20rose%20and%20cream%20colors%20with%20a%20subtle%20film%20reel%20motif%2C%20minimalist%20flat%20design%20style%2C%20clean%20and%20elegant&width=80&height=80&seq=avatar-02&orientation=squarish",
    text: "终于找到一个不是算法推荐而是真正用心选片的平台了！「治愈系电影」那个专题我全看完了，每一部都超棒，睡前看完心情特别好。",
    time: "5 天前",
  },
  {
    id: "cm-3",
    name: "春夜不眠人",
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20circular%20avatar%20icon%20in%20soft%20terracotta%20and%20cream%20colors%20with%20a%20subtle%20star%20pattern%2C%20minimalist%20flat%20design%20style%2C%20clean%20and%20elegant&width=80&height=80&seq=avatar-03&orientation=squarish",
    text: "「深夜悬疑」专题太对胃口了！晚上一个人窝在被窝里看悬疑片简直是最棒的解压方式。画质也很清晰，一点都不卡，赞！",
    time: "1 周前",
  },
  {
    id: "cm-4",
    name: "安静看剧的猫",
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20circular%20avatar%20icon%20in%20soft%20warm%20gold%20and%20cream%20colors%20with%20a%20subtle%20cat%20silhouette%2C%20minimalist%20flat%20design%20style%2C%20clean%20and%20elegant&width=80&height=80&seq=avatar-04&orientation=squarish",
    text: "感谢编辑的精心挑选，每一部片子都值得花时间去品味。在这个快节奏的时代，能有这样一个让人慢下来、安静看电影的地方，真的很珍贵。",
    time: "2 周前",
  },
];

export const rankingItems = [
  { id: "rk-1", rank: 1, title: "海上钢琴师", score: 9.3, tag: "音乐 · 剧情", trend: "up" },
  { id: "rk-2", rank: 2, title: "楚门的世界", score: 9.3, tag: "剧情 · 科幻", trend: "stable" },
  { id: "rk-3", rank: 3, title: "地球脉动 · 第二季", score: 9.9, tag: "纪录片 · 自然", trend: "up" },
  { id: "rk-4", rank: 4, title: "寻梦环游记", score: 9.1, tag: "动画 · 音乐", trend: "stable" },
  { id: "rk-5", rank: 5, title: "小森林 · 夏秋篇", score: 9.0, tag: "美食 · 治愈", trend: "up" },
  { id: "rk-6", rank: 6, title: "情书", score: 8.9, tag: "爱情 · 剧情", trend: "down" },
  { id: "rk-7", rank: 7, title: "步履不停", score: 8.8, tag: "家庭 · 剧情", trend: "stable" },
];

export const mediaItems = [
  {
    id: "md-1",
    title: "春夜影院 · 品牌短片",
    subtitle: "每一个夜晚，都值得一部好电影",
    duration: "01:42",
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20title%20card%20with%20warm%20amber%20and%20soft%20cream%20tones%2C%20elegant%20Chinese%20calligraphy%20style%20typography%20reading%20film%20related%20text%2C%20subtle%20film%20grain%20texture%20overlay%2C%20gentle%20bokeh%20light%20effects%20in%20the%20background%20like%20distant%20city%20lights%20at%20night%2C%20minimalist%20movie%20poster%20aesthetic%20with%20dreamy%20atmosphere%2C%20soft%20glowing%20edges&width=800&height=450&seq=media-01&orientation=landscape",
  },
  {
    id: "md-2",
    title: "七月片单 · 治愈特辑预告",
    subtitle: "20部让你安心入眠的温柔电影",
    duration: "02:15",
    image: "https://readdy.ai/api/search-image?query=A%20dreamy%20montage%20style%20composition%20of%20soft%20nature%20scenes%20with%20gentle%20morning%20light%2C%20blooming%20flowers%2C%20and%20quiet%20countryside%2C%20warm%20pastel%20tones%20of%20cream%20peach%20and%20sage%20green%2C%20ethereal%20cinematic%20mood%20with%20soft%20focus%20edges%2C%20like%20a%20gentle%20film%20trailer%20aesthetic%2C%20peaceful%20and%20calming%20visual%20poetry%20style&width=800&height=450&seq=media-02&orientation=landscape",
  },
  {
    id: "md-3",
    title: "深夜观影指南 · 悬疑篇",
    subtitle: "关灯，戴上耳机，开始烧脑之旅",
    duration: "03:08",
    image: "https://readdy.ai/api/search-image?query=A%20moody%20cinematic%20composition%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20a%20single%20desk%20lamp%20illuminating%20a%20handwritten%20notebook%20with%20film%20notes%2C%20shadows%20of%20venetian%20blinds%20across%20the%20wall%2C%20mysterious%20noir%20atmosphere%2C%20subtle%20film%20reel%20motifs%2C%20sophisticated%20thriller%20aesthetic%20editorial%20style&width=800&height=450&seq=media-03&orientation=landscape",
  },
  {
    id: "md-4",
    title: "动画之夜 · 吉卜力特辑",
    subtitle: "重温那些陪伴我们长大的温柔故事",
    duration: "04:20",
    image: "https://readdy.ai/api/search-image?query=A%20whimsical%20dreamy%20landscape%20with%20rolling%20green%20hills%20under%20a%20soft%20blue%20sky%2C%20whimsical%20clouds%20floating%2C%20a%20small%20cozy%20cottage%20with%20warm%20light%20glowing%20from%20windows%2C%20Ghibli%20inspired%20pastoral%20scenery%2C%20hand%20painted%20animation%20aesthetic%20with%20soft%20watercolor%20textures%2C%20gentle%20and%20nostalgic%20atmosphere%20in%20pastel%20tones&width=800&height=450&seq=media-04&orientation=landscape",
  },
  {
    id: "md-5",
    title: "纪录片之夜 · 自然力量",
    subtitle: "足不出户，看遍地球每一个角落",
    duration: "05:30",
    image: "https://readdy.ai/api/search-image?query=A%20stunning%20wide%20shot%20of%20a%20dramatic%20natural%20landscape%20with%20aurora%20borealis%20dancing%20over%20snow%20capped%20mountains%20reflected%20in%20a%20still%20lake%2C%20star%20filled%20night%20sky%2C%20tiny%20warm%20lights%20from%20a%20distant%20cabin%2C%20majestic%20and%20awe%20inspiring%2C%20BBC%20nature%20documentary%20cinematography%20style%20with%20epic%20scale%20and%20pristine%20colors&width=800&height=450&seq=media-05&orientation=landscape",
  },
];